import { I18n } from '@shared/modules/utils/LangUtil';
import EventService from '@shared/services/EventService';
import React, { Component } from 'react';

class OtpOptionSelectPopup extends Component {
    constructor(props) {
            super(props);
            this.state = {
                contactType:[]
            };
        }

        componentDidMount() {
            let contactList = []
            this.props.contact.forEach((element,i) => {
                if(element.contactType==="EMAIL"){
                    contactList[i]={...element,label:"Email Address"}
                }
                else if(element.contactType==="SMS"){
                    contactList[i]={...element,label:"Mobile Number"}
                }
                else if(element.contactType==="WHATSAPP"){
                    contactList[i]={...element,label:"WhatsApp Number"}
                }
            });
            this.setState({
                contactType:contactList
            })
        }

    onClickSend = (contactType) => {
        if (this.props.callback) this.props.callback(contactType);
        EventService.publish("modal.hide");
    };

    render() {
        let {contactType} =this.state
        return (
            <div className="aling-container">
                <h2>{I18n("g.lbl.otpdestination")}</h2>
                {contactType.map((contact,index)=>(
                    <div className="otp-option" key={index}>
                        <div className="info">
                            <span className="type">{contact.label}</span>
                            <span className='value'>{contact.maskedValue}</span>
                            {
                                contact.verified?
                                <span className="verified">{I18n("g.msg.verified")}</span>
                                :
                                <span className="non-verified">{I18n("g.msg.notverified")}</span>
                            }
                        </div>
                        <button onClick={()=>this.onClickSend(contact)}>{I18n("g.lbl.send")}</button>
                    </div>
                ))}
                

                <button className="cancel-btn" onClick={()=> EventService.publish('modal.hide')}>{I18n("g.action.cancel")}</button>
            </div>
        );
    }
}

export default OtpOptionSelectPopup;